// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/text_format.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schools/v1/resources/text_format.proto.
 */
export const file_studyo_today_schools_v1_resources_text_format = /*@__PURE__*/
  fileDesc("CjNzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvdGV4dF9mb3JtYXQucHJvdG8SIXN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcyp1CgpUZXh0Rm9ybWF0EhsKF1RFWFRfRk9STUFUX1VOU1BFQ0lGSUVEEAASGgoWVEVYVF9GT1JNQVRfUExBSU5fVEVYVBABEhQKEFRFWFRfRk9STUFUX0hUTUwQAhIYChRURVhUX0ZPUk1BVF9NQVJLRE9XThADQimqAiZTdHVkeW8uVG9kYXkuU2Nob29scy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.schools.v1.resources.TextFormat.
 */
export const TextFormatSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_schools_v1_resources_text_format, 0);

/**
 * All possible representations of text to display.
 *
 * @generated from enum studyo.today.schools.v1.resources.TextFormat
 */
export const TextFormat = /*@__PURE__*/
  tsEnum(TextFormatSchema);

